//
//
//
//
//
//
//
//
//
//
//
//
//

import { PAYMENT_GROUPS } from '../../methods'

import InstallmentSimulationModal from './InstallmentSimulationModal'

export default {
  components: {
    InstallmentSimulationModal,
  },

  props: {
    name: {
      type: String,
      default: 'OneyModal',
    },

    /**
     * @typedef {import('@http/transformResponse/transformResponse').Price}
     */
    basePrice: {
      type: Object,
      required: true,
    },

    paymentMethods: {
      type: Array,
      default: null,
    },
  },

  computed: {
    PAYMENT_GROUPS: () => PAYMENT_GROUPS,
  },
}
